import { Star } from "lucide-react";
import { ParticleBackground } from "@/components/ParticleBackground";
import Page from "@/components/layout/Page";

const reviews = [
  {
    name: "Healthcare Professional",
    role: "Occupational Therapist",
    rating: 5,
    review: "The sensory boards that Samboards have created are uniquely designed to be used for either distraction or enjoyment. Touching and feeling the board exercises your hands, increases messages to your brain, and releases natural chemicals which can help a person feel motivated, and improve the sense of well-being."
  },
  {
    name: "Parent Review",
    role: "Customer, 2021",
    rating: 5,
    review: "Hi Samboards, I just wanted to say how great our son finds your small board set. He uses them as a distraction when he feels worried or anxious. Or as an outlet for energy. I find because of their size they are easy to carry around. We have put one on the end of a lanyard and I have one in my handbag just in case. His favourite is the unicorn. I find they are so easy to clean as well, I have popped them through the dishwasher and also just wiped them over with sanitiser wipes when we're out. Thank you for producing a great product."
  },
  {
    name: "Clinical Professional",
    role: "Healthcare",
    rating: 5,
    review: "I recommend these products to many of my patients dealing with anxiety and stress. The tactile engagement provides a healthy coping mechanism and the feedback has been overwhelmingly positive."
  },
  {
    name: "SEND Teacher",
    role: "Education Professional",
    rating: 5,
    review: "We have several sensory boards in our classroom for students who need sensory support. They have helped create a calmer learning environment and students love using them during reading time."
  },
  {
    name: "Michael D.",
    role: "Adult with Autism",
    rating: 5,
    review: "I keep a Mini Samboard on my desk at work. It helps me stay focused during long meetings and provides a discreet way to manage my sensory needs. Highly recommend!"
  },
  {
    name: "Emma L.",
    role: "Parent & Carer",
    rating: 5,
    review: "My mother has dementia and the Samboard has given her something meaningful to engage with. It keeps her hands busy and seems to have a calming effect. Thank you for creating such a thoughtful product."
  }
];

export default function Reviews() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <ParticleBackground className="absolute inset-0 -z-10" />
      
      <Page>
        <div className="pb-24">
          <div className="text-center mb-16">
            <h1 className="text-[40px] sm:text-[48px] lg:text-[54px] leading-[1.1] font-bold mb-4 page-title-gradient">Customer Reviews</h1>
            <p className="text-xl text-slate-200/80">
              See what our customers have to say about Samboards
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {reviews.map((review, index) => (
              <div key={index} className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)] space-y-4">
                <div className="flex gap-1">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-emerald-400 text-emerald-400" />
                  ))}
                </div>
                
                <p className="text-base leading-relaxed text-slate-300/70 italic">
                  "{review.review}"
                </p>
                
                <div className="pt-4 border-t border-white/10">
                  <p className="font-semibold text-slate-100">{review.name}</p>
                  <p className="text-sm text-slate-300/60">{review.role}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)] mt-16 text-center space-y-4">
            <h2 className="text-2xl font-semibold text-slate-100">Experience Samboards for yourself</h2>
            <p className="text-slate-300/70">
              Join thousands of satisfied customers
            </p>
            <a 
              href="/samboards" 
              className="inline-block bg-gradient-to-r from-emerald-400 to-teal-400 text-slate-900 px-8 py-3 rounded-full font-medium hover:from-emerald-300 hover:to-teal-300 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_55px_rgba(16,185,129,0.5)] transition-all"
            >
              Shop now
            </a>
          </div>
        </div>
      </Page>
    </div>
  );
}
